<template>
    <v-app>
        <v-form>
            <v-alert
                    dense
                    outlined
                    type="error"
                    dismissible
                    v-model="alert"
                    v-if="this.alert"
                    @click="alert = true"
            >
                {{ this.error }}
            </v-alert>
            <v-card class="elevation-12" v-if="formState === 'signIn'">
                <v-toolbar
                        color="primary"
                        dark
                        flat
                >
                    <v-toolbar-title>Client Portal</v-toolbar-title>
                    <v-spacer></v-spacer>

                </v-toolbar>
                <v-card-text>
                        <v-text-field
                                label="Username"
                                name="username"
                                prepend-icon="mdi-account"
                                type="text"
                                v-model='form.username'
                        ></v-text-field>
                        <v-text-field
                                id="password"
                                label="Password"
                                name="password"
                                prepend-icon="mdi-lock"
                                type="password"
                                v-model='form.password'
                                @keydown.enter="signIn"
                        ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-btn text small color="grey" v-on:click="forgotPassword">Forgot password?</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" v-on:click="signIn" :loading="loading" >Login</v-btn>
                </v-card-actions>
            </v-card>

            <v-card class="elevation-12" v-if="formState === 'completeSignUp'">
                <v-toolbar
                        color="primary"
                        dark
                        flat
                >
                    <v-toolbar-title>First Time Setup</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                    <v-text-field
                            label="First Name"
                            name="given_name"
                            prepend-icon="mdi-account"
                            type="text"
                            v-model="form.given_name"
                    ></v-text-field>
                    <v-text-field
                            id="family_name"
                            label="Last Name"
                            name="family_name"
                            prepend-icon="mdi-account"
                            type="text"
                            v-model="form.family_name"
                    ></v-text-field>
                    <v-text-field
                            id="password"
                            label="New Password"
                            name="password"
                            :rules="isValidPassword"
                            prepend-icon="mdi-lock"
                            type="password"
                            v-model="form.password"
                            @keydown.enter="completeSetup"
                    ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" v-on:click="completeSetup" :loading="loading" >Submit</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-app>
</template>

<script>
    import { Auth } from 'aws-amplify';
    export default {
        name: "SignIn",
        data() {
            return {
                form: {
                    username: '',
                    password: '',
                    given_name: '',
                    family_name: ''
                },
                formState: 'signIn',
                loading: false,
                error: '',
                alert: false,
                user: {},
                isValidPassword: [
                    value => (value || '').length >= 8 || 'Password must be at least 8 characters long.'
                ]
            }
        },
        methods: {
            async signIn() {
                this.loading = true;
                const { username, password } = this.form;
                await Auth.signIn(username, password).then((user) => {
                    if (user.challengeName === "NEW_PASSWORD_REQUIRED") {
                        this.formState = 'completeSignUp';
                        this.user = user;
                        this.form.password = '';
                        this.loading = false
                    }
                }).catch((err) => {
                    this.loading = false;
                    this.alert = true;
                    this.error = "Invalid username or password. Please try again.";
                })
            },
            forgotPassword() {
                this.formState = 'forgotPassword';
                this.$emit('changeState', this.formState);
            },
            completeSetup() {
                const userAttributes = {
                    family_name: this.form.family_name,
                    given_name: this.form.given_name
                };
                Auth.completeNewPassword(this.user, this.form.password, userAttributes).catch(err => console.log(err))
            }
        }
    }
</script>